// 품질 조절기가 끄고 켜는 환경 '장식 층'을 고르는 순수 로직(three 없음). render/index.ts가 쓰고 시험한다.
// 환경 루트 이름은 두 갈래다: 지역 환경(env/index.ts) = 'env-<지역>', 스테이지 환경(env/stageEnv.ts, S2) = 'stage-env-<지도 키>'.
// 둘 다 같은 규칙으로 찾아야 품질을 낮출 때 스테이지 판의 풀·꽃·불꽃·빛줄기·폭포·접지 그림자·소품이 함께 꺼진다(PR #175 리뷰 P2).

/** 장식 층 판정에 필요한 최소 모양(THREE.Object3D와 맞는다) */
export interface NamedNode { readonly name: string; readonly children?: readonly NamedNode[]; readonly userData?: { [key: string]: unknown } }

/** 세트피스 전용 환경(지역2 지도: 키트 없음)도 장식 효과를 찾을 수 있게, StageEnv가 효과 층에 달아 두는 표시(Object3D.userData) */
export const DECOR_FLAG = 'decor';

/** 작은 소품 키트: 마지막 키트 뒤 효과 층이 아니어도 장식으로 끈다 */
export const SMALL_KITS: ReadonlySet<string> = new Set(['kit-mushrooms', 'kit-crates', 'kit-rubble', 'kit-rock_lo']);

/** 환경 루트 이름인지: 지역 환경 'env-…' 또는 스테이지 환경 'stage-env-…' */
export function isEnvRootName(name: string): boolean {
  return name.startsWith('env-') || name.startsWith('stage-env-');
}

/** 맵 그룹의 자식 중 환경 루트 하나(없으면 undefined) */
export function findEnvRoot<T extends NamedNode>(children: readonly T[]): T | undefined {
  return children.find((c) => isEnvRootName(c.name));
}

/**
 * 환경 루트의 자식 중 장식: 마지막 키트(kit-…) 메시 뒤에 붙는 효과(풀·꽃·불꽃·빛·웅덩이·빛줄기·폭포·접지 그림자)와 작은 소품 키트.
 * 키트가 하나도 없는 세트피스 전용 환경(지역2)은 위치 규칙이 비므로, 명시 표시(userData.decor)가 붙은 효과도 장식으로 본다.
 */
export function decorChildren<T extends NamedNode>(env: { readonly children: readonly T[] }): T[] {
  const out: T[] = [];
  let lastKit = -1;
  env.children.forEach((c, i) => { if (c.name.startsWith('kit-')) lastKit = i; });
  env.children.forEach((c, i) => { if ((lastKit >= 0 && i > lastKit) || SMALL_KITS.has(c.name) || c.userData?.[DECOR_FLAG] === true) out.push(c); });
  return out;
}
